import { types } from 'mobx-state-tree';

export const CalendarEventStore = types
    .model({
        id: types.number,
        graphicsPresentationId: types.maybeNull(types.number),
        categoryPathName: types.maybeNull(types.string),
        name: types.string,
        isLive: types.boolean,
        time: types.Date,
        sportName: types.maybeNull(types.string),
        sportCategoryId: types.maybeNull(types.string),
        isVideoStreamAvailable: types.maybeNull(types.boolean),
        hasActivePrematch: types.boolean
    });